import ticketmasterLogo from 'src/assets/images/ticketmaster.png';
import eventbriteLogo from 'src/assets/images/eventbrite.png';
import ticketwebLogo from 'src/assets/images/ticketweb.png';
import universeLogo from 'src/assets/images/universe.png';
import activeNetworkLogo from 'src/assets/images/active_network.png';
import axsLogo from 'src/assets/images/axs.svg';
import enmotiveLogo from 'src/assets/images/enmotive_logo.png';
import bandsintownLogo from 'src/assets/images/bandsintown_logo.png';
import goldstarLogo from 'src/assets/images/goldstar_favicon.png';
import runSignUpLogo from 'src/assets/images/run_sign_up.svg';
import ticketSignUpLogo from 'src/assets/images/ticket_sign_up.svg';
import eventVestaLogo from 'src/assets/images/event-vesta-logo.png';
import raceEntryLogo from 'src/assets/images/race-entry-logo.png';
import ticketFairyLogo from 'src/assets/images/ticket-fairy-logo.svg';
import meetupLogo from 'src/assets/images/meetup.svg'
import { useTracking } from '../../contexts/trackingContext';

const EventDetailButton = ({ event }) => {
  const { tracker } = useTracking();
  let classes =
    'shadow mx-2 leading-9 text-white font-semibold block text-center rounded-lg p-2 uppercase align-middle whitespace-nowrap';

  const id = 'event-cta';
  let text = 'Get tickets';
  let bgColor;
  let imageSrc;
  let logoPadding = 'p-1.5';

  switch (event.brand) {
    case 'geotix':
    case 'evvnt':
      text = event.ticketsLink ? 'Get Tickets' : 'More Details';
      classes += ' text-theme background-theme';
      break;
    case 'ticketmaster':
      bgColor = '#009cde';
      imageSrc = ticketmasterLogo;
      break;
    case 'eventbrite':
      bgColor = '#ff7300';
      imageSrc = eventbriteLogo;
      break;
    case 'ticketweb':
      bgColor = '#7e4299';
      imageSrc = ticketwebLogo;
      break;
    case 'universe':
      bgColor = '#3A66E5';
      imageSrc = universeLogo;
      break;
    case 'active_network':
      text = 'Register';
      bgColor = '#e8a21b';
      imageSrc = activeNetworkLogo;
      break;
    case 'axs':
      bgColor = '#0054A1';
      imageSrc = axsLogo;
      break;
    case 'enmotive':
      bgColor = '#ff6c0e';
      imageSrc = enmotiveLogo;
      break;
    case 'bandsintown':
      bgColor = '#00B4B5';
      imageSrc = bandsintownLogo;
      break;
    case 'goldstar':
      bgColor = '#FEC214';
      imageSrc = goldstarLogo;
      break;
    case 'run_sign_up':
      bgColor = '#ef509c';
      imageSrc = runSignUpLogo;
      logoPadding = 'p-2';
      break;
    case 'ticket_sign_up':
      bgColor = '#fbad1d';
      imageSrc = ticketSignUpLogo;
      logoPadding = 'p-2';
      break;
    case 'event_vesta':
      bgColor = '#A91CB4';
      imageSrc = eventVestaLogo;
      logoPadding = 'p-1';
      break;
    case 'ticket_fairy':
      bgColor = '#ffac4e';
      imageSrc = ticketFairyLogo;
      logoPadding = 'p-2';
      break;
    case 'race_entry':
      bgColor = '#0385d4';
      imageSrc = raceEntryLogo;
      logoPadding = 'p-0.5';
      break;
    case 'meetup':
      bgColor = '#F65858';
      imageSrc = meetupLogo;
      logoPadding = 'p-0.5';
  }

  const clickProps = {
    targetUrl: event.mainLink,
    elementId: id,
    elementClasses: classes.replace(/\s+/g, ' ').split(' '),
    elementTarget: '_blank',
    elementContent: text,
  };

  const trackEventClick = () => {
    tracker.trackEventClick(event, clickProps);
    return true;
  };

  return (
    <a
      id={id}
      className={classes}
      style={bgColor ? { backgroundColor: `${bgColor}` } : {}}
      href={event.mainLink}
      target="_blank"
      onClick={trackEventClick}
      rel="noopener"
    >
      {text}

      {imageSrc && (
        <img
          src={imageSrc}
          className={`float-right h-9 px-3 bg-white rounded ${logoPadding}`}
          alt={text}
        />
      )}
    </a>
  );
};

export default EventDetailButton;
